/* global jQuery */

class Favicon {
  update(href) {
    const $icon = jQuery("link[rel='shortcut icon']");

    if ($icon.attr('href') !== href) {
      // Firefox doesn't recognise just changing the href, so we need to
      // remove and add it back again.
      const link = document.createElement("link");
      link.type = "image/x-icon";
      link.rel = $icon.attr("rel");
      link.href = href;

      $icon.remove();
      jQuery('head').append(link);
    }
  }
}

export default new Favicon();
